export const FIELD_ROLES = ['field_tech', 'field_coordinator', 'field_management'];

export function isFieldRole(user) {
  return FIELD_ROLES.includes(user?.role);
}

export function getDivisions(user) {
  if (!user) return [];
  if (Array.isArray(user.divisions)) return user.divisions;
  if (isFieldRole(user)) return ['field'];
  return ['shop'];
}

export function defaultLandingPath(user) {
  const d = getDivisions(user);
  if (d.length > 1) return '/home';
  if (d.includes('field')) return '/field/calendar';
  if (d.includes('shop')) return '/dashboard';
  return '/home';
}
